import React from "react"
import Passwordless from "@views/features/passwordless"
import SEO from "@components/SEO"

const IndexPage = () => (
  <div>
    <SEO
      title="EngineID - Passwordless"
      keywords={[
        `engineid`,
        `security`,
        `login fatigue`,
        `password fatigue`,
        `passwordless`,
        `single sign on`,
        `consolidate apps`,
        `password-less`,
        `federated login`,
        `authentication`,
        `cloud`,
        `identity management`,
        `access management`,
      ]}
    />
    <Passwordless />
  </div>
)

export default IndexPage
